<template>
  <v-dialog :value="true" max-width="600" persistent scrollable>
    <v-card>
      <v-card-title>Excluir obligaciones de contratista</v-card-title>
      <v-card-subtitle class="pt-1">
        <div class="subtitle-1 font-weight-medium mb-1">{{ employee.lastName }}, {{ employee.firstName }}</div>
        No se le reclama figurar en las obligaciones de nómina activadas. Sus
        obligaciones propias siguen contando.
      </v-card-subtitle>
      <v-card-text>
        <v-progress-linear v-if="loading" indeterminate class="mb-2" />
        <div v-if="!loading && !obligations.length" class="caption grey--text">
          La contratista no tiene obligaciones de nómina de personal.
        </div>
        <v-switch
          v-for="obligation in obligations"
          :key="obligation._id"
          v-model="selected"
          :value="obligation._id"
          :label="obligation.name"
          :disabled="saving"
          dense
          hide-details
        />
        <v-alert v-if="errorMessage" type="error" dense text class="mt-4">{{ errorMessage }}</v-alert>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn :disabled="saving" @click="$emit('close')">{{ resx.labels.cancel }}</v-btn>
        <v-btn class="primary" :loading="saving" :disabled="loading" @click="save">{{ resx.labels.ok }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
"use strict";

import tagsService from "@/services/TagsService";
import contractorCompanyService from "@/services/ContractorCompanyService";
import { payrollScope, isExcludedFrom } from "@/utils/payroll";

export default {
  name: "employee-obligation-exclusions-dialog",
  props: {
    employee: { type: Object, required: true },
    contractorCompanyId: { type: String, required: true }
  },
  data() {
    return {
      resx: this.$store.state.locale.resx,
      obligations: [],
      selected: [],
      loading: false,
      saving: false,
      errorMessage: null
    };
  },
  async mounted() {
    this.loading = true;
    try {
      const [tags, detail] = await Promise.all([
        tagsService.list(),
        contractorCompanyService.getById(this.contractorCompanyId)
      ]);
      const tagsById = tags.reduce((all, tag) => Object.assign(all, { [tag._id]: tag }), {});
      const contractorType = this.$store.state.constants.OBLIGATIONS.TYPES.OBLIGATION;
      this.obligations = (detail.obligations || []).filter(o => {
        const scope = !o.isDeleted && payrollScope(o, tagsById, contractorType);
        return !!(scope && scope.employees);
      });
      this.selected = this.obligations
        .filter(o => isExcludedFrom(o, this.employee))
        .map(o => o._id);
    } catch (error) {
      this.errorMessage = this.messageOf(error, "No se pudieron cargar las obligaciones");
    } finally {
      this.loading = false;
    }
  },
  methods: {
    messageOf(error, fallback) {
      return (error.response && error.response.data && error.response.data.message) || fallback;
    },
    async save() {
      if (this.saving) return;
      this.errorMessage = null;
      this.saving = true;
      try {
        await contractorCompanyService.setEmployeeObligationExclusions(
          this.contractorCompanyId, this.employee._id, this.selected);
        this.$emit("close");
      } catch (error) {
        this.errorMessage = this.messageOf(error, "No se pudieron guardar las exclusiones");
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>
